import { useSelector } from "@/core/redux/store";
import { useTranslation } from "react-i18next";
import {
  GetActivityTexts,
  GetExploreCompletedCount,
} from "../helper/list-item-helper";
import {
  IInbox,
  InboxType,
} from "@/shared/services/interface/responses/IInboxResponses";
import { useEffect, useState } from "react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shared/components/ui/avatar";
import { Separator } from "@/shared/components/ui/separator";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { Badge } from "@/shared/components/ui/badge";

export default function ActivitySection() {
  const selectedInbox = useSelector((state) => state.inbox.selectedInbox);
  const { t } = useTranslation();
  const activities = useSelector((state) => state.inbox.activities);
  const isLoading = useSelector((state) => state.inbox.activitiesLoading);

  const ActivityItem = ({
    activity,
    lastItem = false,
  }: {
    activity: IInbox;
    lastItem?: boolean;
  }) => {
    if (!selectedInbox) return;

    const { title, date, icon } = GetActivityTexts(
      activity,
      activity.type,
      t,
      selectedInbox
    );
    const [userImage, setUserImage] = useState<string>("");

    const isExploreShow =
      activity?.type ===
        InboxType.SPECIFICATION_EXPLORE_MATCHED_PRODUCT_COMPLETED ||
      activity?.type ===
        InboxType.SPECIFICATION_EXPLORE_USER_AND_COMMENT_COMPLETED ||
      activity?.type ===
        InboxType.SPECIFICATION_EXPLORE_LOCAL_PARTNER_SUPPORT_COMPLETED ||
      activity?.type ===
        InboxType.SPECIFICATION_EXPLORE_COMPETITIVE_INDEX_COMPLETED ||
      activity?.type ===
        InboxType.SPECIFICATION_EXPLORE_PRODUCER_SCORE_COMPLETED;

    useEffect(() => {
      setUserImage("");
    }, [activity]);

    return (
      <div
        key={activity.id}
        className="flex items-center gap-1 px-[11px] mb-[10px] relative"
      >
        <Avatar className="w-3.5 h-3.5 mr-[11px] relative  overflow-visible">
          <AvatarImage src={userImage} />
          <AvatarFallback>{icon}</AvatarFallback>
          {!lastItem && (
            <Separator
              className="absolute top-[17px] left-[50%] translate-x-[-50%] bg-muted-foreground opacity-20 h-[10px]"
              orientation="vertical"
            />
          )}
        </Avatar>
        <div className="flex items-center gap-2">
          <span
            className="text-[12px] font-500"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {isExploreShow && (
            <Badge
              variant="secondary"
              className="!w-[35px] !text-center bg-green-50 !p-0 h-[15px] hover:bg-green-50"
              style={{
                border: "1px solid rgba(22, 163, 74, 0.20)",
              }}
            >
              <span className="text-[10px] text-center text-green-600 w-full">
                {GetExploreCompletedCount(activity.type)} / 5
              </span>
            </Badge>
          )}
        </div>
        {" · "}
        <span className="text-muted-foreground text-[12px] font-500">
          {date}
        </span>
      </div>
    );
  };

  const ActivitySkeleton = () => {
    return (
      <div className="flex items-center gap-1 px-[11px] mb-[10px] relative">
        <Skeleton className="w-3.5 h-3.5 mr-[11px] relative" />
        <Skeleton className="w-[300px] h-[10px]" />
        <Skeleton className="w-[70px] h-[10px]" />
      </div>
    );
  };
  return (
    <div className="flex flex-col ">
      <span className="text-[15px] font-600 text-[#1B1B1B]">
        {t("activity")}
      </span>
      <div className="mt-2 mb-5">
        {isLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <ActivitySkeleton key={index} />
            ))
          : activities?.data.map((activity, index) => {
              return (
                <ActivityItem
                  key={activity.id}
                  activity={activity}
                  lastItem={index === activities?.data.length - 1}
                />
              );
            })}
      </div>
    </div>
  );
}
